define.alias("shared/components/shared/media-items/post-card", "preview-grid/components/shared/media-items/post-card");